(function () {
  "use strict";

  XlsMappingCtrl.$inject = ['$scope', 'xlsConsts', 'xlsAutoMapper'];
  angular
    .module('trainerWebApp.controllers')
    .controller('XlsMappingCtrl', XlsMappingCtrl);

  function XlsMappingCtrl($scope, xlsConsts, xlsAutoMapper) {

    var applied = false;
    var xlsState;
    var continueMessage = 'Double-check to make sure the fields are mapped correctly.';
    var optionalMessage = 'Email or Username with password is required.';

    $scope.infoMessage = continueMessage;

    $scope.noContinue = function () {
      var matchedFields = xlsState.matchedFields;
      var userFields = xlsState.userFields;
      var requiredFieldsMapped = xlsAutoMapper.requiredFieldsMapped(matchedFields, userFields);
      if (!requiredFieldsMapped) {
        populateOptionalMessage(matchedFields, userFields);
      } else {
        $scope.infoMessage = continueMessage;
      }

      return applied || !requiredFieldsMapped;
    };

    $scope.applyMapping = function () {
      applied = true;
      resetUserFields();
      var matchedFields = xlsState.matchedFields;
      var userFields = xlsState.userFields;
      xlsState.emailFieldIdx = -1;
      xlsState.usernameFieldIdx = -1;

      for (var i = 0, c = matchedFields.length; i < c; i++) {
        if (!userFields[i] || !matchedFields[i]) continue;

        userFields[i].columnIdx = matchedFields[i].idx;

        // set email column idx and lowercase email
        if (userFields[i].id == xlsConsts.emailFieldId)
          xlsState.emailColumnIdx = userFields[i].columnIdx;

        // set username column idx
        if (userFields[i].id == xlsConsts.usernameFieldId)
          xlsState.usernameColumnIdx = userFields[i].columnIdx;
      }

      $scope.mappingApplied();
    };

    function populateOptionalMessage(matchedFields, userFields) {
      var whichFieldsUnmapped = xlsAutoMapper.findRequiredMissed(matchedFields, userFields);
      $scope.infoMessage = !whichFieldsUnmapped.optional ? optionalMessage : continueMessage;
    }

    function resetUserFields() {
      var userFields = xlsState.userFields;
      for (var i = 0, c = userFields.length; i < c; i++) {
        userFields[i].columnIdx = null;
      }
      $scope.infoMessage = continueMessage;
    }

    var createPlaceHolder = $scope.createPlaceHolder = function () {
      return {name: '', placeHolder: true};
    };

    function setup() {
      xlsState = $scope.xlsState;

      var amtPlaceHolders = xlsState.userFields.length - xlsState.matchedFields.length;
      for (var i = 0; i < amtPlaceHolders; i++) {
        xlsState.matchedFields.push(createPlaceHolder());
      }
    }

    setup();
  }

})();
